
  document.addEventListener("DOMContentLoaded", function () {
    const faqToggles = document.querySelectorAll(".s-collapse-faq");

    faqToggles.forEach((faq) => {
      const header = faq.querySelector(".s-collapse-faq-header");
      const content = faq.querySelector(".s-collapse-faq-content");
      const svgIcon = header?.querySelector("svg");

      if (!header || !content || !svgIcon) return;

      const toggleHandler = () => {
        const isOpening = !faq.classList.contains("open");

        // Close all other items
        faqToggles.forEach((item) => {
          if (item !== faq) {
            item.classList.remove("open");
            const otherHeader = item.querySelector(".s-collapse-faq-header");
            const otherContent = item.querySelector(".s-collapse-faq-content");

            otherHeader?.classList.remove("open");
            otherContent?.classList.remove("open");
            // Reset maxHeight for smooth re-animation
            if (otherContent) {
              otherContent.style.maxHeight = "0px";
            }
          }
        });

        faq.classList.toggle("open");

        if (isOpening) {
          header.classList.add("open");
          content.classList.add("open");
          // Trigger height transition
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          header.classList.remove("open");
          content.classList.remove("open");
          content.style.maxHeight = "0px";
        }
      };

      header.addEventListener("click", toggleHandler);

      // Optional: clean up on page unload (for SPA frameworks)
      window.addEventListener("unload", () => {
        header.removeEventListener("click", toggleHandler);
      });

      // Reset max-height after expand to allow dynamic content
      content.addEventListener("transitionend", (e) => {
        if (e.propertyName === "max-height" && content.classList.contains("open")) {
          content.style.maxHeight = "none";
        }
      });
    });
  });

